<div id="content" class="container" class="ng-scope">
  <initializing *ngIf="displayLoader"></initializing>
  <ng-container *ngIf="!isInitializing">
    <router-outlet></router-outlet>
  </ng-container>
  <notifications></notifications>
  <screen-shot></screen-shot>
</div>
